import { render } from "./SocialButtons.vue?vue&type=template&id=741d0f05&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"

import "./SocialButtons.vue?vue&type=style&index=0&id=741d0f05&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741d0f05"]])

export default __exports__